export interface Film {
  id: string;
  title: string;
  englishTitle: string;
  category: 'drama' | 'movie' | 'variety' | 'anime';
  subcategory: string;
  year: number;
  rating: number;
  coverImage: string;
  description: string;
  director: string;
  actors: string[];
  region: string;
  episodes: string;
  status: string;
  releaseDate: string;
  tags: string[];
  featured: boolean;
  trending: boolean;
  newRelease: boolean;
}

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'drama', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-computer-line' },
];

export const films: Film[] = [
  {
    id: '1',
    title: '狂飙',
    englishTitle: 'The Knockout',
    category: 'drama',
    subcategory: '刑侦剧',
    year: 2023,
    rating: 9.1,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20Chinese%20crime%20drama%20poster%20featuring%20an%20intense%20police%20officer%20in%20shadow%2C%20urban%20night%20scene%20with%20neon%20reflections%2C%20warm%20amber%20and%20deep%20black%20contrast%2C%20film%20poster%20style%20with%20dramatic%20lighting%2C%20minimalist%20vertical%20composition&width=400&height=560&seq=movie-cover-1&orientation=portrait',
    description: '《狂飙》是一部以扫黑除恶为主题的刑侦剧，讲述了刑警安欣与黑恶势力高启强长达二十年的正邪较量。剧情紧凑，人物刻画深刻，展现了正义与邪恶的激烈交锋，成为2023年度现象级剧集。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    region: '中国大陆',
    episodes: '39集全',
    status: '已完结',
    releaseDate: '2023-01-14',
    tags: ['刑侦', '扫黑', '悬疑', '热门'],
    featured: true,
    trending: true,
    newRelease: false,
  },
  {
    id: '2',
    title: '流浪地球2',
    englishTitle: 'The Wandering Earth II',
    category: 'movie',
    subcategory: '科幻片',
    year: 2023,
    rating: 8.3,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20grand%20Chinese%20sci-fi%20film%20poster%20showing%20a%20massive%20space%20elevator%20against%20a%20burning%20orange%20sky%2C%20futuristic%20technology%20and%20astronauts%2C%20cinematic%20epic%20scale%2C%20warm%20golden%20and%20deep%20space%20contrast%2C%20movie%20poster%20design&width=400&height=560&seq=movie-cover-2&orientation=portrait',
    description: '《流浪地球2》是科幻灾难大片，设定在"太阳危机"即将来袭的背景下。影片讲述了面对末日危机，人类决定启动"移山计划"，建造上万座行星发动机推动地球逃离太阳系，展现了人类面对存亡危机时的勇气与智慧。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    region: '中国大陆',
    episodes: '片长173分钟',
    status: '已上映',
    releaseDate: '2023-01-22',
    tags: ['科幻', '灾难', '冒险', '院线大片'],
    featured: true,
    trending: true,
    newRelease: false,
  },
  {
    id: '3',
    title: '繁花',
    englishTitle: 'Blossoms Shanghai',
    category: 'drama',
    subcategory: '都市剧',
    year: 2024,
    rating: 8.8,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20poster%20set%20in%201990s%20Shanghai%2C%20warm%20golden%20lighting%20on%20a%20stylish%20woman%20in%20qipao%2C%20retro%20Shanghai%20cityscape%20background%2C%20nostalgic%20and%20glamorous%20atmosphere%2C%20film%20poster%20aesthetic&width=400&height=560&seq=movie-cover-3&orientation=portrait',
    description: '《繁花》改编自金宇澄同名小说，由王家卫执导，展现了九十年代上海的时代变迁。故事围绕着阿宝、沪生、小毛三人在大时代背景下的命运起伏，以独特的镜头语言描绘了上海的繁华与沧桑。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    region: '中国大陆',
    episodes: '30集全',
    status: '已完结',
    releaseDate: '2023-12-27',
    tags: ['都市', '年代', '剧情', '文学改编'],
    featured: true,
    trending: true,
    newRelease: false,
  },
  {
    id: '4',
    title: '周处除三害',
    englishTitle: 'The Pig, the Snake and the Pigeon',
    category: 'movie',
    subcategory: '动作片',
    year: 2024,
    rating: 8.1,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20gritty%20Taiwanese%20action%20crime%20film%20poster%2C%20dark%20alley%20with%20a%20lone%20man%20holding%20a%20weapon%2C%20neon%20red%20and%20amber%20lighting%2C%20intense%20and%20raw%20atmosphere%2C%20film%20noir%20style%20poster&width=400&height=560&seq=movie-cover-4&orientation=portrait',
    description: '《周处除三害》以台湾黑帮为背景，讲述了通缉犯陈桂林在生命的最后阶段，决定以暴制暴铲除两大黑帮头目，完成自我救赎的故事。影片以黑色幽默和暴力美学呈现了一场惊心动魄的犯罪旅程。',
    director: '黄精甫',
    actors: ['阮经天', '袁富华', '陈以文', '王净', '谢琼煖'],
    region: '中国台湾',
    episodes: '片长134分钟',
    status: '已上映',
    releaseDate: '2024-03-01',
    tags: ['动作', '犯罪', '黑色幽默', '台湾电影'],
    featured: false,
    trending: true,
    newRelease: true,
  },
  {
    id: '5',
    title: '三体',
    englishTitle: 'Three-Body',
    category: 'drama',
    subcategory: '科幻剧',
    year: 2023,
    rating: 8.5,
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20Chinese%20sci-fi%20drama%20poster%20showing%20three%20suns%20in%20an%20alien%20sky%20with%20a%20lonely%20figure%20on%20a%20desolate%20landscape%2C%20cosmic%20scale%2C%20deep%20space%20colors%20with%20amber%20highlights%2C%20cinematic%20poster%20design&width=400&height=560&seq=movie-cover-5&orientation=portrait',
    description: '《三体》改编自刘慈欣同名科幻巨著，讲述了地球基础科学研究遭遇异常扰动，纳米科学家汪淼与刑警史强联手调查，一步步揭开三体文明与地球文明的首次接触与冲突。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    region: '中国大陆',
    episodes: '30集全',
    status: '已完结',
    releaseDate: '2023-01-15',
    tags: ['科幻', '悬疑', '文学改编', '史诗'],
    featured: false,
    trending: true,
    newRelease: false,
  },
  {
    id: '6',
    title: '热辣滚烫',
    englishTitle: 'YOLO',
    category: 'movie',
    subcategory: '喜剧片',
    year: 2024,
    rating: 7.8,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Chinese%20comedy%20film%20poster%20featuring%20a%20woman%20boxing%20with%20determination%2C%20warm%20golden%20and%20red%20color%20palette%2C%20energetic%20and%20inspiring%20mood%2C%20sports%20drama%20vibe%2C%20movie%20poster%20design&width=400&height=560&seq=movie-cover-6&orientation=portrait',
    description: '《热辣滚烫》讲述了一个大龄单身女性乐莹在经历了生活的种种挫折后，决定通过拳击运动重新找回自我、改变人生的励志故事。影片以温暖幽默的方式诠释了"你只活一次"的人生态度。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫', '沙溢'],
    region: '中国大陆',
    episodes: '片长129分钟',
    status: '已上映',
    releaseDate: '2024-02-10',
    tags: ['喜剧', '励志', '拳击', '春节档'],
    featured: false,
    trending: false,
    newRelease: true,
  },
  {
    id: '7',
    title: '庆余年 第二季',
    englishTitle: 'Joy of Life Season 2',
    category: 'drama',
    subcategory: '古装剧',
    year: 2024,
    rating: 8.6,
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20fantasy%20drama%20poster%2C%20a%20scholar%20in%20elegant%20robes%20standing%20before%20an%20ancient%20palace%2C%20golden%20warm%20lighting%2C%20martial%20arts%20and%20political%20intrigue%20theme%2C%20grand%20cinematic%20poster&width=400&height=560&seq=movie-cover-7&orientation=portrait',
    description: '《庆余年》第二季承接第一季的剧情，范闲在经历了种种磨难后，逐渐揭开身世之谜，在权力斗争中运筹帷幄。剧情融合了权谋、武侠与喜剧元素，延续了第一季的高品质制作。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    region: '中国大陆',
    episodes: '36集全',
    status: '已完结',
    releaseDate: '2024-05-16',
    tags: ['古装', '权谋', '武侠', '热门'],
    featured: true,
    trending: true,
    newRelease: true,
  },
  {
    id: '8',
    title: '年会不能停',
    englishTitle: 'Johnny Keep Walking!',
    category: 'movie',
    subcategory: '喜剧片',
    year: 2024,
    rating: 8.0,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20humorous%20Chinese%20office%20comedy%20film%20poster%2C%20corporate%20workers%20in%20chaotic%20office%20scene%2C%20bright%20warm%20lighting%20with%20satirical%20tone%2C%20modern%20Chinese%20workplace%20satire%2C%20movie%20poster%20design&width=400&height=560&seq=movie-cover-8&orientation=portrait',
    description: '《年会不能停》是一部职场讽刺喜剧，讲述了工厂钳工胡建林阴差阳错被调入集团总部，在光怪陆离的职场生态中闹出了一系列啼笑皆非的故事，深刻揭露了当代职场荒诞现状。',
    director: '董润年',
    actors: ['大鹏', '白客', '庄达菲', '王迅', '孙艺洲'],
    region: '中国大陆',
    episodes: '片长117分钟',
    status: '已上映',
    releaseDate: '2023-12-29',
    tags: ['喜剧', '职场', '讽刺', '院线'],
    featured: false,
    trending: false,
    newRelease: false,
  },
  {
    id: '9',
    title: '海贼王',
    englishTitle: 'One Piece',
    category: 'anime',
    subcategory: '热血动漫',
    year: 1999,
    rating: 9.5,
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20pirate%20crew%20sailing%20on%20a%20grand%20adventure%2C%20colorful%20characters%20with%20straw%20hat%20captain%2C%20epic%20ocean%20background%20with%20golden%20sunset%2C%20Japanese%20anime%20art%20style%2C%20adventure%20theme&width=400&height=560&seq=movie-cover-9&orientation=portrait',
    description: '《海贼王》是尾田荣一郎创作的传奇少年漫画改编动画。讲述了少年路飞为实现与恩人香克斯的约定而出海，在旅途中不断寻找志同道合的伙伴，进入伟大的航道，目标是成为"海贼王"的热血冒险故事。',
    director: '尾田荣一郎（原作）',
    actors: ['田中真弓', '中井和哉', '冈村明美', '山口胜平', '平田广明'],
    region: '日本',
    episodes: '更新至1120集',
    status: '连载中',
    releaseDate: '1999-10-20',
    tags: ['热血', '冒险', '友情', '经典'],
    featured: false,
    trending: true,
    newRelease: false,
  },
  {
    id: '10',
    title: '咒术回战',
    englishTitle: 'Jujutsu Kaisen',
    category: 'anime',
    subcategory: '战斗动漫',
    year: 2023,
    rating: 8.9,
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20anime%20poster%20featuring%20a%20sorcerer%20in%20school%20uniform%20with%20supernatural%20powers%2C%20cursed%20energy%20visual%20effects%20in%20red%20and%20black%2C%20urban%20Tokyo%20setting%2C%20Japanese%20anime%20style%2C%20intense%20battle%20atmosphere&width=400&height=560&seq=movie-cover-10&orientation=portrait',
    description: '《咒术回战》讲述了高中生虎杖悠仁在吞下特级咒物"两面宿傩的手指"后，加入了东京都立咒术高等专门学校，与同伴们一起对抗诅咒的战斗故事。涩谷事变篇将剧情推向高潮。',
    director: '朴性厚（动画监督）',
    actors: ['榎木淳弥', '内田雄马', '濑户麻沙美', '中村悠一', '诹访部顺一'],
    region: '日本',
    episodes: '更新至48集',
    status: '连载中',
    releaseDate: '2020-10-03',
    tags: ['战斗', '超自然', '暗黑', '高人气'],
    featured: false,
    trending: true,
    newRelease: false,
  },
  {
    id: '11',
    title: '奔跑吧 第八季',
    englishTitle: 'Keep Running S8',
    category: 'variety',
    subcategory: '户外真人秀',
    year: 2024,
    rating: 7.5,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Chinese%20variety%20show%20poster%20with%20a%20group%20of%20celebrities%20running%20and%20laughing%20in%20colorful%20outfits%2C%20outdoor%20adventure%20theme%2C%20bright%20and%20energetic%20atmosphere%2C%20reality%20show%20poster%20design&width=400&height=560&seq=movie-cover-11&orientation=portrait',
    description: '《奔跑吧》第八季延续了节目的经典模式，常驻嘉宾和新加入的飞行嘉宾们在中国各地展开趣味竞技和团队挑战，带领观众领略不同城市的风土人情，充满了欢笑与感动。',
    director: '姚译添',
    actors: ['李晨', '郑恺', '沙溢', '白鹿', '周深', '范丞丞'],
    region: '中国大陆',
    episodes: '更新至12期',
    status: '热播中',
    releaseDate: '2024-04-19',
    tags: ['真人秀', '户外', '竞技', '搞笑'],
    featured: false,
    trending: false,
    newRelease: true,
  },
  {
    id: '12',
    title: '歌手2024',
    englishTitle: 'Singer 2024',
    category: 'variety',
    subcategory: '音乐竞演',
    year: 2024,
    rating: 8.2,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20grand%20music%20competition%20show%20poster%20with%20a%20singer%20on%20a%20dramatic%20stage%20with%20spotlights%2C%20golden%20and%20warm%20stage%20lighting%2C%20elegant%20performance%20atmosphere%2C%20Chinese%20variety%20show%20poster&width=400&height=560&seq=movie-cover-12&orientation=portrait',
    description: '《歌手2024》采用全程直播的形式，邀请了国内外顶级歌手同台竞技，以高水准的音乐表演和真实的舞台呈现，重新定义了音乐竞演节目的标准，成为年度最受关注的音乐综艺。',
    director: '洪啸',
    actors: ['那英', '汪苏泷', 'Faouzia', 'Chanté Moore', '海来阿木'],
    region: '中国大陆',
    episodes: '更新至8期',
    status: '热播中',
    releaseDate: '2024-05-10',
    tags: ['音乐', '竞演', '直播', '高水准'],
    featured: false,
    trending: true,
    newRelease: true,
  },
  {
    id: '13',
    title: '神印王座',
    englishTitle: 'Throne of Seal',
    category: 'anime',
    subcategory: '国创动漫',
    year: 2023,
    rating: 8.4,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20poster%20of%20a%20young%20warrior%20with%20magical%20sword%20and%20armor%2C%20fantasy%20medieval%20setting%20with%20castles%20and%20dragons%2C%20epic%20golden%20and%20crimson%20color%20palette%2C%20Chinese%20donghua%20style&width=400&height=560&seq=movie-cover-13&orientation=portrait',
    description: '《神印王座》改编自唐家三少同名小说，讲述了少年龙皓晨为守护人类世界，加入了骑士圣殿，在历练中不断成长，最终登上神印王座，成为人类最强守护者的传奇故事。',
    director: '曾元俊',
    actors: ['马正阳', '常蓉珊', '赵毅', '刘琮'],
    region: '中国大陆',
    episodes: '更新至104集',
    status: '连载中',
    releaseDate: '2023-04-20',
    tags: ['国创', '奇幻', '战斗', '小说改编'],
    featured: false,
    trending: false,
    newRelease: false,
  },
  {
    id: '14',
    title: '飞驰人生2',
    englishTitle: 'Pegasus 2',
    category: 'movie',
    subcategory: '喜剧片',
    year: 2024,
    rating: 7.6,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20racing%20comedy%20film%20poster%20showing%20a%20rally%20car%20speeding%20through%20desert%2C%20dust%20and%20intense%20action%2C%20warm%20sunset%20colors%2C%20adventurous%20and%20humorous%20vibe%2C%20movie%20poster%20design&width=400&height=560&seq=movie-cover-14&orientation=portrait',
    description: '《飞驰人生2》延续了第一部的故事，曾经的赛车冠军张驰在经历低谷后，带领新晋车手厉小海再次踏上巴音布鲁克拉力赛的征程，用速度与激情诠释了不屈不挠的赛车精神。',
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正', '张本煜', '孙艺洲'],
    region: '中国大陆',
    episodes: '片长121分钟',
    status: '已上映',
    releaseDate: '2024-02-10',
    tags: ['喜剧', '赛车', '励志', '春节档'],
    featured: false,
    trending: false,
    newRelease: true,
  },
  {
    id: '15',
    title: '乘风破浪的姐姐 第五季',
    englishTitle: 'Sisters Who Make Waves S5',
    category: 'variety',
    subcategory: '女团竞演',
    year: 2024,
    rating: 7.9,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20glamorous%20Chinese%20reality%20show%20poster%20with%20multiple%20female%20celebrities%20in%20stunning%20stage%20outfits%2C%20dazzling%20stage%20lights%20and%20sparkles%2C%20empowering%20and%20elegant%20vibe%2C%20variety%20show%20poster&width=400&height=560&seq=movie-cover-15&orientation=portrait',
    description: '《乘风破浪的姐姐》第五季邀请了来自不同领域的30+女性艺人，通过舞台竞演展现姐姐们的多面魅力与无限可能，传递女性独立、自信的正能量价值观。',
    director: '任洋',
    actors: ['戚薇', '陈丽君', '刘忻', '何洁', '蔡文静'],
    region: '中国大陆',
    episodes: '更新至10期',
    status: '热播中',
    releaseDate: '2024-04-19',
    tags: ['女团', '竞演', '女性', '热门综艺'],
    featured: false,
    trending: false,
    newRelease: true,
  },
  {
    id: '16',
    title: '进击的巨人 最终季',
    englishTitle: 'Attack on Titan Final Season',
    category: 'anime',
    subcategory: '战斗动漫',
    year: 2023,
    rating: 9.3,
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20intense%20anime%20poster%20of%20a%20soldier%20facing%20giant%20titans%20in%20a%20post-apocalyptic%20world%2C%20deep%20red%20and%20black%20color%20scheme%2C%20dramatic%20and%20tragic%20atmosphere%2C%20Japanese%20anime%20style&width=400&height=560&seq=movie-cover-16&orientation=portrait',
    description: '《进击的巨人》最终季完结篇，艾伦·耶格尔启动了"地鸣"，数千万超大型巨人踏平世界。曾经的伙伴们为了阻止这场灭世浩劫，不得不面对最残酷的抉择，为这个史诗故事画上句号。',
    director: '林祐一郎（动画监督）',
    actors: ['梶裕贵', '石川由依', '井上麻里奈', '下野纮', '小野大辅'],
    region: '日本',
    episodes: '完结篇',
    status: '已完结',
    releaseDate: '2023-11-04',
    tags: ['战斗', '末世', '悲剧', '神作'],
    featured: false,
    trending: true,
    newRelease: false,
  },
];

export const testimonials = [
  {
    id: 1,
    name: '王先生',
    avatar: '',
    rating: 5,
    comment: '木瓜影视真的太方便了，不用注册就能直接看，画质也很清晰，推荐给了身边好多朋友！',
    date: '2024-07-15',
  },
  {
    id: 2,
    name: '李女士',
    avatar: '',
    rating: 5,
    comment: '资源更新速度很快，很多新剧刚播出就能在这里找到。播放流畅不卡顿，观影体验很好。',
    date: '2024-07-20',
  },
  {
    id: 3,
    name: '张同学',
    avatar: '',
    rating: 4,
    comment: '作为一个追剧达人，木瓜影视是我用过最舒心的在线观看平台，分类清晰，找片方便。',
    date: '2024-07-25',
  },
  {
    id: 4,
    name: '刘阿姨',
    avatar: '',
    rating: 5,
    comment: '界面简洁好操作，我这种不太会用手机的人也能轻松找到想看的剧。儿女都夸我会找资源了！',
    date: '2024-07-28',
  },
  {
    id: 5,
    name: '陈先生',
    avatar: '',
    rating: 5,
    comment: '动漫资源很全，海贼王、咒术回战都有更新。高清画质看动漫太享受了，强烈推荐！',
    date: '2024-07-30',
  },
  {
    id: 6,
    name: '赵女士',
    avatar: '',
    rating: 4,
    comment: '在家带娃的间隙追剧是我的日常，木瓜影视的即点即播功能真的省心，不用折腾下载什么的。',
    date: '2024-08-01',
  },
];

export const siteInfo = {
  name: '木瓜影视',
  slogan: '免费在线观看 · 高清即点即播',
  description: '木瓜影视是一家专业的在线视频观看平台，致力于为用户提供免费、高清、流畅的影视观看体验。我们收录了海量最新电视剧、电影、综艺和动漫资源，无需下载注册，打开网页即可享受影院级观影体验。',
  established: '2020年',
  userCount: '超过500万',
  filmCount: '超过10万部',
  updateFrequency: '每日更新',
  contactEmail: 'contact@muguays.com',
  contactWechat: 'muguays_official',
  contactQQ: '1234567890',
};